/* =========================================================================
   Palette Studio — assets/palette-studio.js (bearly.art)
   Runs on the Bearly Tools shell. GA4: pushes pl_* events to window.dataLayer;
   the shared core (assets/bearly-tools-core.js) forwards them to GA4.
   Download popup + email gate: the ONE shared popup in the core
   (BT.runWithProgress). This file only passes its wording (stages, gate text,
   done/error text) and the export as `work`; the core shows progress, asks for
   the email once for ALL tools (logged-in customers skip, fail-open), handles
   × / Escape / backdrop (no file; pl_email_dismiss) and fires pl_email_view /
   pl_email_submit. pl_download_click + "Used Palette Studio" fire inside `work`,
   only once a PNG was actually produced.
   ========================================================================= */

/* ---------------- Tracking + Klaviyo helpers ---------------- */
var plTrack = function (name, params) {
  var o = params ? JSON.parse(JSON.stringify(params)) : {};
  o.event = name;
  (window.dataLayer = window.dataLayer || []).push(o);
};

var PL_TOOL = { name: "Palette Studio", handle: "palette-studio" };

// Klaviyo events go through the core (known email, adds tool + tool_handle; no-op
// until the visitor's email is known).
var plKlaviyoEvent = function (name, props) {
  try { if (window.BT && typeof window.BT.klaviyoEvent === "function") window.BT.klaviyoEvent(name, props); } catch (e) {}
};

/* ---------------- Palette engine ---------------- */
(function () {
  "use strict";

  var root = document.getElementById("palette-root");
  if (!root) return;

  var $ = function (id) { return document.getElementById(id); };

  plTrack("pl_tool_view", { page_location: location.href });

  /* ---------- color math ---------- */
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  function rgb2hex(c) {
    return "#" + c.map(function (v) { return clamp(Math.round(v), 0, 255).toString(16).padStart(2, "0"); }).join("").toUpperCase();
  }
  function hex2rgb(h) {
    h = String(h).replace("#", "");
    if (h.length === 3) h = h.split("").map(function (c) { return c + c; }).join("");
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
    var n = parseInt(h, 16);
    return [n >> 16 & 255, n >> 8 & 255, n & 255];
  }
  function rgb2hsl(c) {
    var r = c[0] / 255, g = c[1] / 255, b = c[2] / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, h = 0;
    if (d) {
      if (mx === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h *= 60;
    }
    var l = (mx + mn) / 2;
    var s = d ? d / (1 - Math.abs(2 * l - 1)) : 0;
    return [h, s * 100, l * 100];
  }
  function hsl2rgb(c) {
    var h = ((c[0] % 360) + 360) % 360, s = c[1] / 100, l = c[2] / 100;
    var C = (1 - Math.abs(2 * l - 1)) * s, x = C * (1 - Math.abs((h / 60) % 2 - 1)), m = l - C / 2, r, g, b;
    if (h < 60) { r = C; g = x; b = 0; }
    else if (h < 120) { r = x; g = C; b = 0; }
    else if (h < 180) { r = 0; g = C; b = x; }
    else if (h < 240) { r = 0; g = x; b = C; }
    else if (h < 300) { r = x; g = 0; b = C; }
    else { r = C; g = 0; b = x; }
    return [(r + m) * 255, (g + m) * 255, (b + m) * 255].map(Math.round);
  }
  function rgb2lab(c) {
    var f = function (v) { v /= 255; return v > 0.04045 ? Math.pow((v + 0.055) / 1.055, 2.4) : v / 12.92; };
    var R = f(c[0]), G = f(c[1]), B = f(c[2]);
    var x = (R * 0.4124 + G * 0.3576 + B * 0.1805) / 0.95047,
        y = (R * 0.2126 + G * 0.7152 + B * 0.0722),
        z = (R * 0.0193 + G * 0.1192 + B * 0.9505) / 1.08883;
    var g2 = function (v) { return v > 0.008856 ? Math.cbrt(v) : (7.787 * v) + 16 / 116; };
    x = g2(x); y = g2(y); z = g2(z);
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  }
  var labDist = function (a, b) { return Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]); };
  var luminance = function (c) { return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]; };
  var textColorFor = function (c) { return luminance(c) > 150 ? "#232528" : "#FFFFFF"; };
  function mulberry32(a) {
    return function () {
      a |= 0; a = a + 0x6D2B79F5 | 0;
      var t = Math.imul(a ^ a >>> 15, 1 | a);
      t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
      return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
  }

  /* ---------- state + DOM ---------- */
  var state = {
    hasImage: false,
    seed: 1,
    count: 5,
    swatches: [],   // {anchor:[h,s,l], dh, ds, dl, locked, alternates:[[r,g,b],...]}
    selected: -1,
    picking: false,
    samples: null,  // [{rgb, lab}]
    tweaked: false
  };

  var canvas = $("pl-canvas"), ictx = canvas.getContext("2d", { willReadFrequently: true });
  var strip = $("pl-strip"), imageWrap = $("pl-imagewrap"), drop = $("pl-drop");
  var tweak = $("pl-tweak"), exportBtn = $("pl-export"), reshuffleBtn = $("pl-reshuffle");

  function toast(msg) {
    if (window.BT && typeof window.BT.toast === "function") { window.BT.toast(msg); return; }
    $("pl-img-info").textContent = msg;
  }
  function markTweaked(kind) {
    if (state.tweaked) return;
    state.tweaked = true;
    plTrack("pl_swatch_tweaked", { kind: kind });
  }

  /* ---------- HEIC + decode (iPhone-safe) ---------- */
  var heicLoader = null;
  function ensureHeic2any() {
    if (!heicLoader) {
      heicLoader = new Promise(function (res, rej) {
        var s = document.createElement("script");
        s.src = "https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js";
        s.onload = res;
        s.onerror = function () { heicLoader = null; rej(new Error("heic2any failed to load")); };
        document.head.appendChild(s);
      });
    }
    return heicLoader;
  }
  function heicToJpeg(file) {
    return ensureHeic2any().then(function () {
      return heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 });
    }).then(function (out) { return Array.isArray(out) ? out[0] : out; });
  }
  function decodeViaImg(blob) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); res(img); };
      img.onerror = function () { URL.revokeObjectURL(url); rej(new Error("decode failed")); };
      img.src = url;
    });
  }
  function decodeImage(blob) {
    if ("createImageBitmap" in window) {
      return createImageBitmap(blob, { imageOrientation: "from-image" }).catch(function () { return decodeViaImg(blob); });
    }
    return decodeViaImg(blob);
  }

  /* ---------- image loading ---------- */
  function loadFile(file) {
    if (!file) return;
    var isHeic = /\.hei[cf]$/i.test(file.name || "") || /hei[cf]/i.test(file.type || "");
    if (!isHeic && file.type && file.type.indexOf("image/") !== 0) {
      toast("That isn't an image file");
      plTrack("pl_upload_error", { message: "not an image", file_type: file.type });
      return;
    }
    $("pl-img-info").textContent = "Loading…";
    var blobPromise = isHeic ? heicToJpeg(file) : Promise.resolve(file);
    blobPromise
      .then(function (blob) {
        return decodeImage(blob).catch(function (err) {
          if (!isHeic) return heicToJpeg(file).then(decodeImage);
          throw err;
        });
      })
      .then(function (img) {
        var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
        var sc = Math.min(1, 2400 / Math.max(w, h));
        canvas.width = Math.round(w * sc);
        canvas.height = Math.round(h * sc);
        ictx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.classList.remove("pl-hidden");
        drop.classList.add("pl-hidden");
        state.hasImage = true;
        reshuffleBtn.disabled = false;
        exportBtn.disabled = false;
        $("pl-img-info").textContent = (file.name || "Pasted image") + " — " + w + "×" + h + "px";
        buildSamples();
        state.seed = (Math.random() * 1e9) | 0;
        extractAndApply(true);
        plTrack("pl_file_upload", { file_type: file.type || "unknown", px_w: w, px_h: h });
        plKlaviyoEvent("Started " + PL_TOOL.name, { file_type: file.type || "unknown" });
      })
      .catch(function () {
        $("pl-img-info").textContent = "Couldn't read that photo. Try a JPEG or PNG.";
        plTrack("pl_upload_error", { message: "decode failed", file_type: file.type || "unknown" });
      });
  }

  function buildSamples() {
    var max = 140, sc = Math.min(1, max / Math.max(canvas.width, canvas.height));
    var w = Math.max(1, Math.round(canvas.width * sc)), h = Math.max(1, Math.round(canvas.height * sc));
    var c = document.createElement("canvas"); c.width = w; c.height = h;
    var cx = c.getContext("2d");
    cx.drawImage(canvas, 0, 0, w, h);
    var d = cx.getImageData(0, 0, w, h).data;
    var pts = [], stride = Math.max(1, Math.floor((w * h) / 5000));
    for (var i = 0; i < w * h; i += stride) {
      var o = i * 4; if (d[o + 3] < 200) continue;
      var rgb = [d[o], d[o + 1], d[o + 2]];
      pts.push({ rgb: rgb, lab: rgb2lab(rgb) });
    }
    state.samples = pts;
  }

  /* ---------- k-means (lab space, seeded, kmeans++ init) ---------- */
  function kmeans(points, k, rng) {
    if (!points.length) return [];
    k = Math.min(k, points.length);
    var cents = [points[(rng() * points.length) | 0].lab.slice()];
    while (cents.length < k) {
      var d2 = points.map(function (p) {
        var m = Infinity;
        for (var c = 0; c < cents.length; c++) m = Math.min(m, labDist(p.lab, cents[c]));
        return m * m;
      });
      var sum = d2.reduce(function (a, b) { return a + b; }, 0) || 1;
      var r = rng() * sum, idx = 0;
      for (var i = 0; i < d2.length; i++) { r -= d2[i]; if (r <= 0) { idx = i; break; } }
      cents.push(points[idx].lab.slice());
    }
    var assign = new Array(points.length).fill(0);
    for (var it = 0; it < 14; it++) {
      var moved = false;
      for (var p = 0; p < points.length; p++) {
        var best = 0, bd = Infinity;
        for (var c2 = 0; c2 < cents.length; c2++) {
          var dd = labDist(points[p].lab, cents[c2]);
          if (dd < bd) { bd = dd; best = c2; }
        }
        if (assign[p] !== best) { assign[p] = best; moved = true; }
      }
      var sums = cents.map(function () { return [0, 0, 0, 0]; });
      for (var q = 0; q < points.length; q++) {
        var s = sums[assign[q]], l = points[q].lab;
        s[0] += l[0]; s[1] += l[1]; s[2] += l[2]; s[3]++;
      }
      for (var c3 = 0; c3 < cents.length; c3++) {
        if (sums[c3][3]) cents[c3] = [sums[c3][0] / sums[c3][3], sums[c3][1] / sums[c3][3], sums[c3][2] / sums[c3][3]];
      }
      if (!moved) break;
    }
    // per cluster: the real sample pixel nearest the centroid, plus population
    return cents.map(function (c, ci) {
      var best = null, bd = Infinity, count = 0;
      for (var i = 0; i < points.length; i++) {
        if (assign[i] !== ci) continue;
        count++;
        var dd = labDist(points[i].lab, c);
        if (dd < bd) { bd = dd; best = points[i]; }
      }
      return best ? { rgb: best.rgb, lab: best.lab, count: count } : null;
    }).filter(Boolean);
  }

  /* ---------- palette extraction: main picks + alternates ---------- */
  function extractCandidates(n) {
    var rng = mulberry32(state.seed);
    var k = Math.min(18, Math.max(n + 4, n * 3));
    var clusters = kmeans(state.samples, k, rng).sort(function (a, b) { return b.count - a.count; });
    if (!clusters.length) return { main: [], rest: [] };
    // greedy: population weight x distance from already-chosen = diverse but representative
    var chosen = [clusters[0]], pool = clusters.slice(1);
    while (chosen.length < Math.min(n, clusters.length) && pool.length) {
      var bi = 0, bs = -1;
      pool.forEach(function (c, i) {
        var md = Math.min.apply(null, chosen.map(function (ch) { return labDist(c.lab, ch.lab); }));
        var sc = Math.sqrt(c.count) * md;
        if (sc > bs) { bs = sc; bi = i; }
      });
      chosen.push(pool.splice(bi, 1)[0]);
    }
    return { main: chosen, rest: pool };
  }
  function makeSwatch(rgb, alternates) {
    return { anchor: rgb2hsl(rgb), dh: 0, ds: 0, dl: 0, locked: false, alternates: alternates };
  }
  function attachAlternates(main, rest) {
    return main.map(function (m) {
      var alts = rest
        .map(function (r) { return { r: r, d: labDist(r.lab, m.lab) }; })
        .filter(function (o) { return o.d > 3; })
        .sort(function (a, b) { return a.d - b.d; })
        .slice(0, 4)
        .map(function (o) { return o.r.rgb; });
      // pad with tints/shades so there are always options
      var hsl = rgb2hsl(m.rgb);
      while (alts.length < 4) {
        var off = (alts.length % 2 ? 1 : -1) * (10 + alts.length * 3);
        alts.push(hsl2rgb([hsl[0], hsl[1], clamp(hsl[2] + off, 4, 96)]));
      }
      return makeSwatch(m.rgb, alts);
    });
  }
  function swColor(sw) {
    return hsl2rgb([sw.anchor[0] + sw.dh, clamp(sw.anchor[1] + sw.ds, 0, 100), clamp(sw.anchor[2] + sw.dl, 2, 98)]);
  }
  function extractAndApply(fresh) {
    var lockedList = state.swatches.filter(function (s) { return s.locked; });
    var need = state.count - Math.min(lockedList.length, state.count);
    var cand = extractCandidates(state.count + lockedList.length);
    var lockedLabs = lockedList.map(function (s) { return rgb2lab(swColor(s)); });
    // avoid refilling with near-duplicates of locked colors
    var filtered = cand.main.filter(function (m) {
      return lockedLabs.every(function (ll) { return labDist(m.lab, ll) > 14; });
    });
    var source = (filtered.length >= need ? filtered : cand.main).slice(0, need);
    var fill = attachAlternates(source, cand.rest.concat(cand.main));
    state.swatches = lockedList.slice(0, state.count).concat(fill)
      .slice(0, state.count)
      .sort(function (a, b) { return luminance(swColor(a)) - luminance(swColor(b)); });
    if (fresh || state.selected < 0 || state.selected >= state.swatches.length) {
      state.selected = state.swatches.length ? 0 : -1;
    }
    renderStrip(); renderPanel();
  }

  /* ---------- strip ---------- */
  var LOCK_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>';
  var UNLOCK_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 7.5-1.9"/></svg>';
  function renderStrip() {
    strip.innerHTML = "";
    state.swatches.forEach(function (sw, i) {
      var rgb = swColor(sw), hex = rgb2hex(rgb), fg = textColorFor(rgb);
      var b = document.createElement("button");
      b.type = "button";
      b.className = "pl-swatch" + (sw.locked ? " locked" : "") + (i === state.selected ? " selected" : "");
      b.style.background = hex;
      b.setAttribute("role", "option");
      b.setAttribute("aria-selected", i === state.selected ? "true" : "false");
      b.setAttribute("aria-label", hex + (sw.locked ? ", locked" : ""));
      b.innerHTML = '<span class="hex" style="color:' + fg + '">' + hex.slice(1) + '</span>' +
        '<span class="lock" style="color:' + fg + '">' + (sw.locked ? LOCK_SVG : UNLOCK_SVG) + '</span>';
      b.addEventListener("click", function (e) {
        if (e.target.closest(".lock")) { sw.locked = !sw.locked; markTweaked("lock"); renderStrip(); renderPanel(); return; }
        if (state.selected === i) { copyHex(hex); return; }
        state.selected = i; renderStrip(); renderPanel();
      });
      strip.appendChild(b);
    });
  }
  function copyHex(hex) {
    var done = function () { toast(hex + " copied"); };
    var fallback = function () {
      var ta = document.createElement("textarea");
      ta.value = hex; document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); } catch (e) {}
      ta.remove(); done();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(hex).then(done, fallback);
    else fallback();
  }

  /* ---------- tweak step (always visible) ---------- */
  function renderPanel() {
    if (!state.swatches[state.selected] && state.swatches.length) state.selected = 0;
    var sw = state.swatches[state.selected];
    tweak.classList.toggle("empty", !sw);
    $("pl-tweak-empty").classList.toggle("pl-hidden", !!sw);
    tweak.querySelectorAll(".pl-tweak__ctrls input, .pl-tweak__ctrls button").forEach(function (el) { el.disabled = !sw; });
    if (!sw) {
      setPicking(false);
      $("pl-chip").style.background = "";
      $("pl-hex").value = "";
      $("pl-alts").innerHTML = "";
      return;
    }
    var hex = rgb2hex(swColor(sw));
    $("pl-chip").style.background = hex;
    if (document.activeElement !== $("pl-hex")) $("pl-hex").value = hex;
    $("pl-hue").value = sw.dh; $("pl-sat").value = sw.ds; $("pl-lit").value = sw.dl;
    $("pl-hue-out").textContent = (sw.dh > 0 ? "+" : "") + sw.dh + "°";
    $("pl-sat-out").textContent = (sw.ds > 0 ? "+" : "") + sw.ds;
    $("pl-lit-out").textContent = (sw.dl > 0 ? "+" : "") + sw.dl;
    $("pl-lock").textContent = sw.locked ? "Unlock" : "Lock";
    var alts = $("pl-alts"); alts.innerHTML = "";
    sw.alternates.forEach(function (a) {
      var ah = rgb2hex(a), btn = document.createElement("button");
      btn.type = "button";
      btn.style.background = ah; btn.title = ah; btn.setAttribute("aria-label", "Use " + ah);
      btn.addEventListener("click", function () {
        sw.anchor = rgb2hsl(a); sw.dh = sw.ds = sw.dl = 0;
        markTweaked("alternate"); renderStrip(); renderPanel();
      });
      alts.appendChild(btn);
    });
  }

  function bindSlider(id, key) {
    $(id).addEventListener("input", function (e) {
      var sw = state.swatches[state.selected]; if (!sw) return;
      sw[key] = +e.target.value;
      markTweaked("slider"); renderStrip(); renderPanel();
    });
  }
  bindSlider("pl-hue", "dh"); bindSlider("pl-sat", "ds"); bindSlider("pl-lit", "dl");

  $("pl-hex").addEventListener("change", function (e) {
    var sw = state.swatches[state.selected]; if (!sw) return;
    var rgb = hex2rgb(e.target.value.trim());
    if (!rgb) { toast("That isn't a valid hex code"); renderPanel(); return; }
    sw.anchor = rgb2hsl(rgb); sw.dh = sw.ds = sw.dl = 0;
    markTweaked("hex"); renderStrip(); renderPanel();
  });
  $("pl-lock").addEventListener("click", function () {
    var sw = state.swatches[state.selected]; if (!sw) return;
    sw.locked = !sw.locked; markTweaked("lock"); renderStrip(); renderPanel();
  });
  $("pl-copy").addEventListener("click", function () {
    var sw = state.swatches[state.selected]; if (sw) copyHex(rgb2hex(swColor(sw)));
  });

  /* ---------- eyedropper ---------- */
  function setPicking(on) {
    state.picking = on;
    imageWrap.classList.toggle("picking", on);
    $("pl-pick").textContent = on ? "Click the image…" : "Pick from image";
    if (!on) $("pl-pickchip").style.display = "none";
  }
  $("pl-pick").addEventListener("click", function () { setPicking(!state.picking); });

  // Map a pointer event to a canvas pixel.
  // The canvas is CSS-sized with width:100% + max-height + object-fit:contain, so when the
  // height is capped the image is drawn letterboxed (centered) inside a wider element box.
  // Map against the actual drawn image rect, not the element box. Returns null in the bars.
  function canvasPos(e) {
    var r = canvas.getBoundingClientRect();
    if (!r.width || !r.height || !canvas.width || !canvas.height) return null;
    var sc = Math.min(r.width / canvas.width, r.height / canvas.height);
    var dw = canvas.width * sc, dh = canvas.height * sc;
    var ox = r.left + (r.width - dw) / 2, oy = r.top + (r.height - dh) / 2;
    var x = (e.clientX - ox) / sc, y = (e.clientY - oy) / sc;
    if (x < 0 || y < 0 || x >= canvas.width || y >= canvas.height) return null;
    return [clamp(Math.floor(x), 0, canvas.width - 1), clamp(Math.floor(y), 0, canvas.height - 1)];
  }
  canvas.addEventListener("mousemove", function (e) {
    if (!state.picking) return;
    var chip = $("pl-pickchip");
    var p = canvasPos(e);
    if (!p) { chip.style.display = "none"; return; }
    var d = ictx.getImageData(p[0], p[1], 1, 1).data;
    var hex = rgb2hex([d[0], d[1], d[2]]);
    var r = imageWrap.getBoundingClientRect();
    chip.style.display = "block";
    chip.style.left = (e.clientX - r.left + 14) + "px";
    chip.style.top = (e.clientY - r.top + 14) + "px";
    chip.querySelector(".c").style.background = hex;
    chip.querySelector(".t").textContent = hex.slice(1);
  });
  canvas.addEventListener("mouseleave", function () { $("pl-pickchip").style.display = "none"; });
  canvas.addEventListener("click", function (e) {
    if (!state.picking) return;
    var sw = state.swatches[state.selected]; if (!sw) { setPicking(false); return; }
    var p = canvasPos(e);
    if (!p) return; // clicked in the letterbox area — keep picking
    var d = ictx.getImageData(p[0], p[1], 1, 1).data;
    sw.anchor = rgb2hsl([d[0], d[1], d[2]]); sw.dh = sw.ds = sw.dl = 0;
    setPicking(false); markTweaked("eyedropper"); renderStrip(); renderPanel();
  });

  /* ---------- palette controls ---------- */
  function setCount(n) {
    state.count = clamp(n, 3, 8);
    $("pl-count").textContent = state.count;
    if (state.hasImage) extractAndApply(false);
  }
  $("pl-count-down").addEventListener("click", function () { setCount(state.count - 1); });
  $("pl-count-up").addEventListener("click", function () { setCount(state.count + 1); });
  function reshuffle() {
    if (!state.hasImage) return;
    state.seed = (Math.random() * 1e9) | 0;
    extractAndApply(false);
  }
  reshuffleBtn.addEventListener("click", reshuffle);
  document.addEventListener("keydown", function (e) {
    if (e.code !== "Space" || !state.hasImage) return;
    if (e.target.closest && e.target.closest("input,textarea,select,button,a,[contenteditable],.bt-proc")) return;
    if (document.querySelector(".bt-proc")) return;
    e.preventDefault(); reshuffle();
  });

  /* ---------- input: click / drag / paste ---------- */
  var fileInput = $("pl-file-input");
  var openPicker = function () { fileInput.click(); };
  $("pl-load-btn").addEventListener("click", openPicker);
  drop.addEventListener("click", openPicker);
  drop.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openPicker(); } });
  fileInput.addEventListener("change", function (e) {
    if (e.target.files && e.target.files[0]) loadFile(e.target.files[0]);
    e.target.value = "";
  });
  var stage = root.querySelector(".pl-stage");
  ["dragover", "dragenter"].forEach(function (ev) {
    stage.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add("over"); });
  });
  ["dragleave", "drop"].forEach(function (ev) {
    stage.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove("over"); });
  });
  stage.addEventListener("drop", function (e) {
    var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (f) loadFile(f);
  });
  document.addEventListener("paste", function (e) {
    if (e.target.closest && e.target.closest("input,textarea")) return;
    var items = (e.clipboardData && e.clipboardData.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image/") === 0) { loadFile(items[i].getAsFile()); break; }
    }
  });

  /* ---------- download popup (shared core) ---------- */
  // BT.runWithProgress owns the popup, the email step and the × / Escape / backdrop
  // close. `work` returns a promise that rejects if no PNG was made, so the core closes
  // the popup and shows EXPORT_ERR as its toast.
  var EXPORT_ERR = "Sorry, we couldn't make your palette file. Try a smaller photo.";
  function runExport(work) {
    exportBtn.disabled = true;
    var reenable = function () { exportBtn.disabled = !state.hasImage; };
    if (window.BT && BT.runWithProgress) {
      BT.runWithProgress({
        stages: [
          { p: 22, wait: 350, text: "Reading your photo…" },
          { p: 58, wait: 800, text: "Mixing your swatches…" },
          { p: 84, wait: 800, text: "Printing the hex codes…" }
        ],
        gateText: "Your file is almost ready! Enter your email to get it.",
        doneText: "Your file is ready!",
        errorText: EXPORT_ERR,
        work: work,
        onEnd: reenable
      }).then(function (r) { if (r.status === "busy") reenable(); });
    } else {
      // Old core cached: no popup, just make the file.
      Promise.resolve().then(work).catch(function (e) {
        if (window.console) console.error("[Palette Studio]", e);
        toast(EXPORT_ERR);
      }).then(reenable);
    }
  }

  /* ---------- export: photo on top, swatch strip with vertical hex labels ---------- */
  exportBtn.addEventListener("click", function () {
    if (!state.hasImage || !state.swatches.length) return;
    runExport(function () {
      var n = state.swatches.length;
      return doExport().then(function () {
        plTrack("pl_download_click", { swatches: n });
        plKlaviyoEvent("Used " + PL_TOOL.name, { swatches: n });
      });
    });
  });

  function doExport() {
    var W = Math.min(canvas.width, 1600);
    var imgH = Math.round(W * canvas.height / canvas.width);
    var stripH = Math.round(imgH * 0.42);
    var gap = Math.max(4, Math.round(W * 0.008));
    var n = state.swatches.length;
    var out = document.createElement("canvas");
    out.width = W; out.height = imgH + gap + stripH;
    var ctx = out.getContext("2d");
    ctx.fillStyle = "#FFFFFF"; ctx.fillRect(0, 0, out.width, out.height);
    ctx.drawImage(canvas, 0, 0, W, imgH);
    var swW = (W - gap * (n - 1)) / n;
    var fs = Math.round(Math.min(swW * 0.30, stripH * 0.15));
    state.swatches.forEach(function (sw, i) {
      var rgb = swColor(sw), hex = rgb2hex(rgb);
      var x = i * (swW + gap);
      ctx.fillStyle = hex;
      ctx.fillRect(x, imgH + gap, swW, stripH);
      ctx.save();
      ctx.translate(x + swW / 2, imgH + gap + fs * 0.9);
      ctx.rotate(Math.PI / 2);
      ctx.font = "600 " + fs + "px 'Spline Sans Mono', monospace";
      ctx.textAlign = "left"; ctx.textBaseline = "middle";
      ctx.fillStyle = textColorFor(rgb);
      ctx.fillText(hex.slice(1), 0, 0);
      ctx.restore();
    });
    return download(out, "palette.png");
  }

  // Resolves once the PNG was handed to the browser; rejects if no image was made.
  function download(cnv, name) {
    return new Promise(function (resolve, reject) {
    cnv.toBlob(function (blob) {
      if (!blob) { reject(new Error("toBlob returned no image")); return; }
      var url = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url; a.rel = "noopener";
      if ("download" in a) {
        a.download = (window.BT && BT.brandName ? BT.brandName(name) : name);
        document.body.appendChild(a); // required for iOS Safari/Chrome
        a.click();
        a.remove();
      } else {
        window.open(url, "_blank");
      }
      setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
      resolve();
    }, "image/png");
    });
  }

  // make sure the mono font is ready before anyone exports
  if (document.fonts && document.fonts.load) document.fonts.load("600 14px 'Spline Sans Mono'").catch(function () {});

  renderPanel();
})();